import { render, staticRenderFns } from "./DialogDuyetDongKo.vue?vue&type=template&id=996b419e&"
import script from "./DialogDuyetDongKo.vue?vue&type=script&lang=js&"
export * from "./DialogDuyetDongKo.vue?vue&type=script&lang=js&"
import style0 from "./DialogDuyetDongKo.vue?vue&type=style&index=0&id=996b419e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports